import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "Modal"
}
const _hoisted_2 = { class: "Modal-Box" }


import TutorialModalVue from "./modal/TutorialModal.vue";

type Props = {
	isVisible: boolean;
};


export default /*#__PURE__*/_defineComponent({
  props: {
    isVisible: { type: Boolean }
  },
  emits: ["onClickClose"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
	isVisible: boolean;
}




const onClickClose = () => {
	emits("onClickClose");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "Modal-TS" }, {
    default: _withCtx(() => [
      (props.isVisible)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(TutorialModalVue, { onOnClickClose: onClickClose })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})